import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logoHV.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-e2eeec34")

_pushScopeId("data-v-e2eeec34")
const _hoisted_1 = { class: "layout-topbar p-d-flex p-jc-between" }
const _hoisted_2 = /*#__PURE__*/_createVNode("a", { href: "/" }, [
  /*#__PURE__*/_createVNode("img", {
    alt: "logo",
    src: _imports_0,
    height: "40",
    class: "p-mr-2"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Menubar = _resolveComponent("Menubar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Menubar, { model: $setup.appMenu }, {
      start: _withId(() => [
        _hoisted_2
      ]),
      end: _withId(() => [
        (!$props.isLoggedIn)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'login' }
            }, {
              default: _withId(() => [
                _createVNode(_component_Button, {
                  label: "Đăng nhập",
                  icon: "pi pi-sign-in",
                  iconPos: "right"
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              label: "Đăng xuất",
              onClick: $setup.logout,
              icon: "pi pi-sign-out",
              iconPos: "right",
              class: "p-btton-warning"
            }, null, 8, ["onClick"]))
      ]),
      _: 1
    }, 8, ["model"])
  ]))
})